<template>
  <div class="navPanel flex-center-center" id="homeNavPanel">
    <div class="content12 navContentPanel flex-center-start">
      <div class="logoPanel flex">
        <img class="logo" src="@/images/com/logo.png" alt />
      </div>
      <div class="wrapper flex-end-center">
        <div
          class="navItem"
          :class="{ active: index == nowIndex }"
          v-for="(tabItem, index) in tabParams"
          @click="tabToggle(index, tabItem.path)"
          :key="index"
        >
          <span :class="{ dropdownBtn: index == 5 }" @click="dropdown">{{
            tabItem.name
          }}</span>
          <ul v-if="index == 5" class="dropdownWrapper" v-show="dropdownActive">
            <li
              class="dropdownWrapperLi"
              v-for="(item, index) in dropParams"
              :key="index"
              @click="closeDropdown"
            >
              <a target="_blank" :href="item.path">{{ item.name }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dropParams } from "@/utils/com_data"; 
export default {
  data() {
    return {
      dropParams,
      nowIndex: 1,
      dropdownActive: false,
      tabParams: [
        { name: "首页", path: "home" },
        { name: "主会场", path: "theMainVenue" },
        { name: "分会场", path: "branchVenue" },
        { name: "金陀螺奖", path: "goldenTopAward" },
        { name: "创意互动展区", path: "cloudExhibitionArea" },
        // { name: "大会动态", path: "conferenceNews" },
        { name: "往届回顾", path: "" },
      ],
    };
  },
  methods: {
    dropdown: function () {
      if (event.target.getAttribute("class") === "dropdownBtn") {
        this.dropdownActive = !this.dropdownActive;
      }
    },

    tabToggle: function (index, path) {
      this.nowIndex = index;
      localStorage.setItem("nowIndex", index);
      if(!path) return
      this.dropdownActive = false;
      this.$router.push({ name: path });
    },
    closeDropdown() {
      this.dropdownActive = false;
    },
  },
  created() {
    var noindex = localStorage.getItem("nowIndex");
    this.nowIndex = noindex;
  },
};
</script>

<style lang="scss" scoped>
.navPanel {
  width: 100%;
  height: 0.6rem;
  background: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
}
.navContentPanel {
  height: 100%;
}
.logo {
  width: 1.43rem;
  height: 0.3rem;
}
.wrapper {
  flex: 1;
  height: 100%;
}
.navItem {
  font-size: 0.16rem;
  font-weight: 500;
  color: #f6dae0;
  border-bottom: 3px solid transparent;
  padding: 0 0 0.19rem 0;
  span {
    display: inline-block;
  }
}
.navItem:not(:last-child) {
  margin-right: 0.7rem;
}
.navItem.active {
  color: rgba(221, 25, 32, 1);
  border-bottom: 3px solid rgba(221, 25, 32, 1);
  font-weight: bold;
}
.dropdownWrapper {
  width: 1.52rem;
  height: 3.06rem;
  background: #ffffff;
  box-shadow: 0rem 0.02rem 0.08rem 0rem rgba(0, 0, 0, 0.15);
  border-radius: 0.04rem;
  position: absolute;
  top: 0.6rem;
  z-index: 9999;
}
.dropdownWrapperLi {
  height: 0.33rem;
  line-height: 0.33rem;
  a {
    display: inline-block;
    text-align: left;
    font-size: 0.14rem;
    font-weight: 400;
    color: #666666;
    padding: 0 0 0 0.16rem;
  }
}
.dropdownBtn {
  display: inline-block;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/com/black/headerNav.vue